import { message } from "antd";
import axiosInstance from "../axiosInstance";

import {
	FETCH_SCORE_RULES_REQUEST,
	FETCH_SCORE_RULES_SUCCESS,
	FETCH_SCORE_RULES_FAIL,
	UPDATE_SCORE_RULE_REQUEST,
	UPDATE_SCORE_RULE_SUCCESS,
	UPDATE_SCORE_RULE_FAIL,
	FETCH_SCORE_RULE_REQUEST,
	FETCH_SCORE_RULE_SUCCESS,
	FETCH_SCORE_RULE_FAIL,
} from "../constants/scoreRule";

const fetchScoreRules = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_SCORE_RULES_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/score-rules", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_SCORE_RULES_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_SCORE_RULES_FAIL, payload: errorMessage });
	}
};

const updateScoreRule = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_SCORE_RULE_REQUEST });
	try {
		const { data } = await axiosInstance.patch(
			`/admin/score-rules/${id}`,
			values,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);

		message.success("Updated.");
		dispatch({
			type: UPDATE_SCORE_RULE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_SCORE_RULE_FAIL, payload: errorMessage });
	}
};

const fetchScoreRule = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_SCORE_RULE_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/score-rules/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_SCORE_RULE_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_SCORE_RULE_FAIL, payload: errorMessage });
	}
};

export { fetchScoreRules, updateScoreRule, fetchScoreRule };
